export function getMicrositeInfo(state, micrositeInfo) {
  Object.assign(state.micrositeInfo, micrositeInfo);
}
export function getMicrositeMembers(state, micrositeMembers) {
  Object.assign(state.micrositeMembers, micrositeMembers);
}
export function getMicrositeEvents(state, micrositeEvents) {
  Object.assign(state.micrositeEvents, micrositeEvents);
}